import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { SecteurActiviteService } from "../../services/secteur-activite.service";
import { SecteurActivitePayload } from "../../models/secteur-activite";
import { Utils } from "src/app/shared/utils/utils";

declare let swal: any;

@Component({
  selector: "app-form-secteur-activite",
  templateUrl: "./form-secteur-activite.component.html",
  styleUrls: ["./form-secteur-activite.component.css"],
})
export class FormSecteurActiviteComponent implements OnInit {

  form: FormGroup;
  busy: Subscription;
  secteurId: number | null = null;
  isEditMode: boolean = false;

  constructor(
    private fb: FormBuilder,
    private secteurActiviteService: SecteurActiviteService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.initForm();

    this.secteurId = this.route.snapshot.params["id"]
      ? +this.route.snapshot.params["id"]
      : null;

    if (this.secteurId) {
      this.isEditMode = true;
      this.loadSecteur(this.secteurId);
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      nom:         ["", Validators.required],
      description: [""],
      actif:       [true],
    });
  }

  loadSecteur(id: number): void {
    this.busy = this.secteurActiviteService.getById(id).subscribe(
      (data: any) => {
        this.form.patchValue({
          nom:         data.nom,
          description: data.description,
          actif:       data.actif,
        });
      },
      () => {
        Utils.sweetAlert("error", "Erreur", "Erreur lors du chargement du secteur");
      }
    );
  }

  onSubmit(): void {
    if (this.form.invalid) return;

    const payload: SecteurActivitePayload = this.form.value;

    if (this.isEditMode) {
      this.busy = this.secteurActiviteService.update(this.secteurId, payload).subscribe(
        () => {
          Utils.sweetAlert("success", "Succès", "Secteur modifié avec succès");
          this.router.navigate(["/secteurs-activite"]);
        },
        () => {
          Utils.sweetAlert("error", "Erreur", "Erreur lors de la modification");
        }
      );
    } else {
      this.busy = this.secteurActiviteService.create(payload).subscribe(
        () => {
          Utils.sweetAlert("success", "Succès", "Secteur ajouté avec succès");
          this.router.navigate(["/secteurs-activite"]);
        },
        () => {
          Utils.sweetAlert("error", "Erreur", "Erreur lors de l'ajout");
        }
      );
    }
  }

  goBack(): void {
    this.router.navigate(["/secteurs-activite"]);
  }
}
